import { Tag } from '../../../cdl/Tag/Tag';
import { Tooltip } from '../../../cdl/Tooltip/Tooltip';
import { formatDate } from '../../../common/helpers/formatDate.helper';
import { translate } from '../../../common/helpers/translate.helper';
import { IconClock } from '../../../common/icons/cdl/Clock';
import { Box } from '../../../common/ui/Box';

interface OutdatedPriceTagProps {
    validUntil?: string;
}

export const OutdatedPriceTag = ({ validUntil }: OutdatedPriceTagProps) => {
    const tooltipLabel = (
        <Box style={{ textAlign: 'center' }}>
            {translate('order.supplierSelection.outdatedTooltip')}
            {validUntil ? (
                <Box paddingTop={16}>
                    {translate('order.supplierSelection.outdatedTooltipValidUntil', {
                        date: formatDate({ date: validUntil }),
                    })}
                </Box>
            ) : null}
        </Box>
    );

    return (
        <Tooltip label={tooltipLabel} maxWidth="320px" showArrow>
            <Tag Icon={IconClock}>{translate('order.supplierSelection.outdated')}</Tag>
        </Tooltip>
    );
};
